import {useState} from 'react';

/** Returns array of randomly generated numbers that persist through re-renders unless parameters are changed.*/
export const useRandom = (countOfRandomNumbers: number) => {
  const [randomNumbers, setRandomNumbers] = useState<number[]>(() => {
    return generateNumbers(countOfRandomNumbers);
  });

  return {
    randomNumbers,
    generateNewRandomNumbers: () => setRandomNumbers(generateNumbers(countOfRandomNumbers)),
  };
};

function generateNumbers(countOfRandomNumbers: number) {
  const array = [];
  for (let index = 0; index < countOfRandomNumbers; index++) {
    array.push(Math.random());
  }
  return array;
}
